module.exports = __webpack_public_path__ + "img/no_data.b61ed979.png";